<div>
    <br />
    <div class="form-content">
        <p>You have been logged out due to inactivity. Please <a class="underline" (click)="login()">click here</a>
            to sign in.</p>
    </div>
</div>